var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ClassifierTree/nodes/dndOrdering.ts";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import { mergeReactRefs } from '@gmini/utils/lib/mergeReactRefs';
import React, { useCallback } from 'react';
import { useDrag, useDragLayer, useDrop } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';
import { pathEquals } from "../utils";
export function useOrderingNodeDnd(_ref) {
  var onDroppedBefore = _ref.onDroppedBefore,
      onDroppedAfter = _ref.onDroppedAfter,
      canDropBefore = _ref.canDropBefore,
      canDropAfter = _ref.canDropAfter,
      node = _ref.node,
      path = _ref.path;
  var divRef = React.useRef(null);

  var _useDragLayer = useDragLayer(function (monitor) {
    var _monitor$getClientOff;

    return {
      y: (_monitor$getClientOff = monitor.getClientOffset()) === null || _monitor$getClientOff === void 0 ? void 0 : _monitor$getClientOff.y
    };
  }),
      y = _useDragLayer.y;

  var canDrop = useCallback(function (item, monitor) {
    var _monitor$getClientOff2;

    if (!pathEquals(item.path.slice(0, -1), path.slice(0, -1))) {
      return false;
    }

    var _getDndState = getDndState({
      divRef: divRef,
      isOverOrdering: monitor.isOver(),
      y: (_monitor$getClientOff2 = monitor.getClientOffset()) === null || _monitor$getClientOff2 === void 0 ? void 0 : _monitor$getClientOff2.y
    }),
        isBottomOver = _getDndState.isBottomOver,
        isTopOver = _getDndState.isTopOver;

    if (isBottomOver) {
      return canDropAfter({
        target: item.node
      });
    } else if (isTopOver) {
      return canDropBefore({
        target: item.node
      });
    }

    return false;
  }, [canDropAfter, canDropBefore, path]);

  var _useDrop = useDrop({
    accept: ['ORDERING'],
    canDrop: canDrop,
    drop: function drop(_ref2) {
      var type = _ref2.type,
          node = _ref2.node,
          path = _ref2.path;

      var _getDndState2 = getDndState({
        divRef: divRef,
        isOverOrdering: isOverOrdering,
        y: y
      }),
          isBottomOver = _getDndState2.isBottomOver,
          isTopOver = _getDndState2.isTopOver;

      if (isBottomOver) {
        onDroppedAfter({
          target: node
        });
      } else if (isTopOver) {
        onDroppedBefore({
          target: node
        });
      }
    },
    collect: function collect(m) {
      return {
        isOverOrdering: m.isOver(),
        canDrop: m.canDrop()
      };
    }
  }),
      _useDrop2 = _slicedToArray(_useDrop, 2),
      _useDrop2$ = _useDrop2[0],
      isOverOrdering = _useDrop2$.isOverOrdering,
      canDropOrdering = _useDrop2$.canDrop,
      dropOrderingRef = _useDrop2[1];

  var _useDrag = useDrag({
    item: {
      node: node,
      path: path,
      type: 'ORDERING'
    },
    collect: function collect(monitor) {
      return {
        isDragging: monitor.isDragging()
      };
    }
  }),
      _useDrag2 = _slicedToArray(_useDrag, 3),
      dragOrderingRef = _useDrag2[1],
      preview = _useDrag2[2];

  React.useEffect(function () {
    preview(getEmptyImage(), {
      captureDraggingState: false
    });
  }, [preview]);

  var _getDndState3 = getDndState({
    divRef: divRef,
    isOverOrdering: isOverOrdering,
    y: y
  }),
      isBottomOver = _getDndState3.isBottomOver,
      isTopOver = _getDndState3.isTopOver;

  return {
    isOverOrdering: isOverOrdering,
    dropOrderingRef: mergeReactRefs(dropOrderingRef, divRef),
    dragOrderingRef: dragOrderingRef,
    isTopOver: isTopOver,
    isBottomOver: isBottomOver,
    canDropOrdering: canDropOrdering
  };
}

function getDndState(_ref3) {
  var divRef = _ref3.divRef,
      isOverOrdering = _ref3.isOverOrdering,
      y = _ref3.y;

  var getTopOffset = function getTopOffset() {
    var _divRef$current;

    var elementClientRect = (_divRef$current = divRef.current) === null || _divRef$current === void 0 ? void 0 : _divRef$current.getBoundingClientRect();

    if (!elementClientRect) {
      return -Infinity;
    }

    var yDiff = y ? y - (elementClientRect === null || elementClientRect === void 0 ? void 0 : elementClientRect.top) : 0;
    return yDiff;
  };

  var topOffsetDiff = getTopOffset();
  var isTopOver = isOverOrdering && topOffsetDiff >= -rowMargin && topOffsetDiff < overMinimumPercents * rowHeight;
  var isBottomOver = isOverOrdering && topOffsetDiff <= rowHeight && topOffsetDiff > overMinimumPercents * rowHeight;
  return {
    isTopOver: isTopOver,
    isBottomOver: isBottomOver
  };
}

var rowHeight = 40;
var rowMargin = 10;
var overMinimumPercents = 0.3;